// The provider may route a requested model to a different served model, and
// no response exists while a strategy job is in progress. Do not present a
// model name as fact until the completed request reports one.
export const strategyGenerationProgressLabel = () => 'Working on your strategy…';
